import {getData} from './index'

export const getEmployeeList = async ({ token ,  params = {}}) => {
    const res = await getData({endpoint : 'Employee/GetAllEmployeesValueLabel', token,params})
    return res?.data
}

export const getRolesList = async ({ token}) => {
    const res = await getData({endpoint : 'Role/GetAllRolesList', token})
    return res?.data
}

export const getdepartmentList = async ({ token}) => {
    const res = await getData({endpoint : 'Department/getDepartmentList', token})
    return res
}

export const getClientList = async ({token}) =>{
    const res = await getData({endpoint : 'Client/getAllClientsList',token})
    return res
}

export const getBusinessSegmentList = async ({token}) =>{
    const res = await getData({endpoint : 'BusinessSegment/getAllAsyncValueLabel',token})
    return res
}


export const getTeamsList = async ({token ,  params = {} }) =>{
    const res = await getData({endpoint : 'Team/getAllTeamsList',token,params})
    return res
}

export const getAllProjects = async ({token , params = {}}) =>{
    const res = await getData({endpoint : 'Project/getProjectList',token,params})
    return res
}

export const getTaskLogTime = async ({token , task_id}) => {
    const res = await getData({endpoint : 'TaskTimer/getTimersByTaskId', params : {taskId : task_id}, token :  token})
    return res
}

